import { useAnalytics as useAnalyticsHook } from 'use-analytics';
import { AnalyticsInstance } from 'analytics';

export default function useAnalytics(): AnalyticsInstance {
  return useAnalyticsHook();
}
